import {
  Box,
  Chip,
  ToggleButton,
  ToggleButtonGroup,
  Typography
} from '@mui/material';
import { changePlan } from '../../changeplanCss';
import { newChangePlan } from '../../newChangePlan';
import {
  changePlanText,
  changePlanTextNew,
  paths
} from 'src/common/config/TextMessage';
import { priceOrbitText } from 'src/content/dashboard/TextMessages';

interface PricingHeaderProps {
  headerDivRef: React.RefObject<HTMLDivElement>;
  isLocalSeo?: boolean;
  selectedValue: string;
  checked: boolean;
  handleToggleChange: (event: any, newValue: string) => void;
}

export const PricingHeader = ({
  headerDivRef,
  isLocalSeo,
  selectedValue,
  checked,
  handleToggleChange
}: PricingHeaderProps) => {
  const isLocalSeoAndPricePage =
    isLocalSeo && paths.price === window.location.pathname;

  return (
    <div ref={headerDivRef}>
      <div className="flex items-center justify-center">
        <Typography
          sx={{
            fontFamily: 'Inter',
            fontSize: '44px',
            fontWeight: '600',
            lineHeight: '60px',
            letterSpacing: '-0.02em',
            textAlign: 'center',
            color: 'var(--color-text-primary)',
            marginBottom: '15px',
            marginTop: '15px'
          }}
        >
          {isLocalSeoAndPricePage ? (
            <>
              {changePlanTextNew?.onePrice}{' '}
              <span style={{ color: 'var(--color-secondary)' }}>
                {changePlanTextNew?.full}
              </span>{' '}
              {changePlanTextNew?.access}
            </>
          ) : (
            <>
              <span style={{ color: 'var(--color-secondary)' }}>Flexible</span>{' '}
              Pricing for Every <br /> Squarespace Site
            </>
          )}
        </Typography>
      </div>
      <div className="flex items-center justify-center">
        <Typography
          sx={{
            ...newChangePlan.pricingDescriptionStyle(isLocalSeo),
            width: 'auto'
          }}
        >
          {
            isLocalSeoAndPricePage
              ? changePlanTextNew?.localSeoPricingDesc
              : priceOrbitText?.title
            // changePlanTextNew?.pricingDescription
          }
          <br />
          {isLocalSeoAndPricePage && changePlanTextNew?.localSeoPricingDescTwo}
        </Typography>
      </div>

      {/* switch button for year and month  */}
      <Box
        className="flex justify-center "
        sx={{ ...changePlan?.switchBtnBox, height: '55px', width: '300px' }}
      >
        <ToggleButtonGroup
          color="primary"
          value={selectedValue}
          exclusive
          onChange={handleToggleChange}
          aria-label="Platform"
          sx={changePlan?.toggleButtonGroupSx}
        >
          <ToggleButton
            value="monthly"
            disableRipple
            // className={checked ? 'active-toggle' : 'inactive-toggle'}
            sx={changePlan?.toggleButtonSx}
          >
            <Typography
              className="text-label"
              sx={{
                ...(checked
                  ? {
                      fontFamily: 'Inter',
                      fontSize: 'var(--font-size-15)',
                      backgroundColor: (theme) => theme.palette.primary.main,
                      borderRadius: '100px',
                      width: '138px',
                      paddingTop: '10px',
                      paddingBottom: '10px',
                      textTransform: 'none',
                      color: 'white'
                    }
                  : {
                      textTransform: 'none',
                      width: '138px',
                      border: '1px solid var(--color-bg-light-purple)',
                      borderRadius: '100px',
                      color: 'var(--color-text-primary)'
                    }),
                fontWeight: '600',
                border: 'none',
                font: '15px'
              }}
            >
              {changePlanText?.billedMonthly}
            </Typography>
          </ToggleButton>

          <ToggleButton
            value="annually"
            disableRipple
            sx={changePlan?.toggleButtonSx}
          >
            <Typography
              className="text-label"
              sx={{
                ...(!checked
                  ? {
                      fontFamily: 'Inter',
                      fontSize: 'var(--font-size-15)',
                      backgroundColor: (theme) => theme.palette.primary.main,
                      borderRadius: '100px',
                      width: '138px',
                      paddingTop: '10px',
                      paddingBottom: '10px',
                      textTransform: 'none',
                      color: 'white'
                    }
                  : {
                      textTransform: 'none',
                      width: '138px',
                      border: '1px solid var(--color-bg-light-purple)',
                      borderRadius: '100px',
                      color: 'var(--color-text-primary)'
                    }),
                fontWeight: '600',
                border: 'none',
                font: '15px'
              }}
            >
              {changePlanText?.billedAnnually}
            </Typography>
            <Chip
              label={
                isLocalSeoAndPricePage ? (
                  <Typography
                    sx={{ ...changePlan?.chipText, fontWeight: '600' }}
                  >
                    {changePlanTextNew?.saveUptoText}
                  </Typography>
                ) : (
                  <Typography
                    sx={{ ...changePlan?.chipText, fontWeight: '600' }}
                  >
                    &#127881; {changePlanTextNew?.monthsFree}
                  </Typography>
                )
              }
              sx={{
                ...changePlan?.saveUptoChip,
                width: '130px',
                top: '-19px',
                right: '5px'
              }}
            />
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
    </div>
  );
};
